import SubjectAreaModelBase from '../_generated/modelBases/subject-area-model-base';

export default class SubjectAreaModel extends SubjectAreaModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
